/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

/**
 * Payload for capturing a telemetry event
 */
export type CaptureEventPayload = {
  /**
   * Distinct ID for the user or entity (defaults to organization ID if not provided)
   */
  distinctId?: string | undefined;
  /**
   * Event name
   */
  event: string;
  /**
   * Event properties as key-value pairs
   */
  properties?: { [k: string]: any } | undefined;
};

/** @internal */
export type CaptureEventPayload$Outbound = {
  distinct_id?: string | undefined;
  event: string;
  properties?: { [k: string]: any } | undefined;
};

/** @internal */
export const CaptureEventPayload$outboundSchema: z.ZodMiniType<
  CaptureEventPayload$Outbound,
  CaptureEventPayload
> = z.pipe(
  z.object({
    distinctId: z.optional(z.string()),
    event: z.string(),
    properties: z.optional(z.record(z.string(), z.any())),
  }),
  z.transform((v) => {
    return remap$(v, {
      distinctId: "distinct_id",
    });
  }),
);

export function captureEventPayloadToJSON(
  captureEventPayload: CaptureEventPayload,
): string {
  return JSON.stringify(
    CaptureEventPayload$outboundSchema.parse(captureEventPayload),
  );
}
